import React from "react";
import { connect } from "react-redux";
import { Card, Badge, Button } from "react-bootstrap";
import "../Computer.css";

const ComputerCard = ({
    s_no,
    ComputerId,
    ComputerName,
    OS,
    SystemType,
    licenseType,
    getComputerDetailView,
    computer,
    editComputer,
    deleteComputer,
    Username,
    isAdmin
}) => {

    return (
        <Card
            className="cards computer-card"
            onClick={(e) => {
                e.preventDefault();
                getComputerDetailView(ComputerId, "details");
            }}
        >

            <Card.Body>

                {/* License */}
                 <div className="card-header-row">

                    {/* <Badge
                        bg={
                            licenseType === "Licensed"
                                ? "success"
                                : licenseType === "OpenSource"
                                    ? "primary"
                                    : "danger"
                        }
                        className="license-badge"
                    >
                        {licenseType}
                    </Badge> */}

                </div> 


                {/* Computer Icon */}
                <div className="computer-icon">

                    {SystemType === "PC" ? (
                        <i className="bi bi-pc-display"></i>
                    ) : (
                        <i className="bi bi-laptop"></i>
                    )}

                </div>


                {/* Computer Name */}
                <h4 className="computer-name">
                    {ComputerName}
                </h4>


                {/* Assigned User */}
                <div className="assigned-user">

                    <i className="bi bi-person-circle"></i>

                    <span>
                        {Username}
                    </span>

                </div>


                {/* Divider */}
                <div className="card-divider"></div>


                {/* Actions */}
                <div
                    className="computer-actions"
                    onClick={(e) => e.stopPropagation()}
                >

                    {/* View */}
                    <Button
                        variant="outline-primary"
                        size="sm"
                        className="computer-action-btn"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            getComputerDetailView(
                                ComputerId,
                                "details"
                            );
                        }}
                    >
                        <i className="bi bi-eye-fill"></i>
                    </Button>


                    {/* Admin Actions */}
                    {isAdmin && (
                        <>
                            <Button
                                variant="outline-dark"
                                size="sm"
                                className="computer-action-btn edit-btn"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    editComputer(
                                        ComputerId,
                                        "edit"
                                    );
                                }}
                            >
                                <i className="bi bi-pencil-fill"></i>
                            </Button>


                            <Button
                                variant="outline-danger"
                                size="sm"
                                className="computer-action-btn delete-btn"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    deleteComputer(ComputerId);
                                }}
                            >
                                <i className="bi bi-trash-fill"></i>
                            </Button>
                        </>
                    )}

                </div>

            </Card.Body>

        </Card>
    );
};

const mapStateToProps = (state) => {
    return {};
};

export default connect(mapStateToProps, null)(ComputerCard);